import { round } from "./Numbers"

export const nanoSecondsToMilliSeconds = (nanoseconds) => round(nanoseconds / 1e6, 1)
